import web3 from 'web3'
// import { getUserLevel } from '@/contract/index'

const user = {
  state: {
    accountAddress: '',
    /** 是否为 SellWine.manager（链上 isOwner），未连接或未判定时为 false */
    isSellWineOwner: false,
    userData: {
      level: 0,
    },
  },

  mutations: {
    SET_ADDRESS: (state, address) => {
      state.accountAddress = address
    },
    SET_IS_SELLWINE_OWNER: (state, v) => {
      state.isSellWineOwner = !!v
    },
    SET_USERDATA: (state, userData) => {
      state.userData = userData
    },
  },

  actions: {
    // loadUserData({ commit, state }) {
    //   return new Promise(async (resolve, reject) => {
        
    //     resolve()
    //   })
    // },
  },
}

export default user
